import React from "react";

const UpGrad = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M4.35 27.667L2 25.303l12.345-12.67 6.048 6.42 7.308-6.42L24.929 9H34l-1.176 9.376-3.57-3.59-8.861 8.912-6.048-6.082-9.995 10.05z"
            fill={fill}
        />
    </svg>
);

export default UpGrad;
